import React from 'react'
import AboutCompany from './AboutCompany'
import Achievements from './Achievements'
import EligibilitySlider from './EligibilitySlider'
import SimpleProcess from './SimpleProcess'
import OurServices from './OurServices'

const Home = () => {
  return (
    <div>

      <section className="welcome_area main" id="home">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge">New</p>
                    </div>
                    <span className="integration-text">
                      Whenever Your Loan Need Can’t Wait
                    </span>
                  </div>
                </div>
                <h1 className="b-text bold">
                  We truly understand what you need.
                </h1>
                <p>
                  Me Loans makes borrowing simple with fast, flexible, and transparent loans built around your needs
                </p>
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="/contact-us" className="btn more-btn mr-3">
                    contact us
                  </a>
                  <a className="btn more-btn" href="/apply-for-loan">

                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>

      <section className="section-padding-0-100 our-facts">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 offset-lg-0 col-md-12 no-padding-left">
              <div className="welcome-meter fadeInUp" data-wow-delay="0.7s">
                <img draggable="false" src="image/about-loan.png" alt="" />
              </div>
            </div>
            <div className="col-12 col-lg-6 offset-lg-0 col-md-10 offset-md-1">
              <div className="who-we-contant mt-s">

                <h4 className="fadeInUp" data-wow-delay="0.3s">
                  About Me Loans Company
                </h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                  Me Loans is a reliable financial services company offering a wide range of loan solutions designed to meet every stage of your financial journey. Whether you are planning to buy a home, grow your business, or manage personal expenses, Me Loans provides customized financing options to suit your needs.
                 </p> <p className="fadeInUp" data-wow-delay="0.4s">We offer Home Loan solutions to help you purchase your dream home, refinance your existing property, or renovate your current house. Our Personal Loan options provide quick access to funds for medical emergencies, travel, debt consolidation, or other personal requirements.
</p>
                  <p className="fadeInUp" data-wow-delay="0.4s">For entrepreneurs and growing enterprises, our Business Loan products deliver flexible funding to expand operations, manage working capital, or invest in new opportunities. If you're investing in real estate, our Property Loan options are designed to make property purchases simple and affordable...............
                </p>
                 
                <a
                  className="btn more-btn mt-30 fadeInUp"
                  data-wow-delay="0.6s"
                  href="/about-us"
                >
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>


       
      <SimpleProcess />

      <OurServices />

      <EligibilitySlider />
      <Achievements />


    </div>
  )
}

export default Home
